// extracted by mini-css-extract-plugin
export default {"container":"TestimonialTable_container__kR8qb","justify":"TestimonialTable_justify__0ifXL","btnContainer":"TestimonialTable_btnContainer__cyKyf"};